import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { LoaderService } from '../../../services/loader/loader.service';
import { HttpService } from '../../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

const SELECTED_LIMIT = 1;

export interface DialogData {
  patientId: string;
  type: string;
  patientDetails: {},
  bookingData?: {},
}


/**
 * This component is use to select book the appointment, by selecting date and time
 */

@Component({
  selector: 'app-book-appointment',
  templateUrl: './book-appointment-popup.component.html',
  styleUrls: ['./book-appointment-popup.component.scss']
})
export class BookAppointmentPopupComponent implements OnInit {
  appointmentFrom: FormGroup;
  showMatProgress = false;
  minDate =  new Date();
  appointmentData:any = [];
  selectedService: any = {};
  setDate = new FormControl(new Date());
  selectedDate = new Date()
  patientDetails: any = {}
  patientId: any = ""
  isSubmitBtnDisabled = true;

  constructor(
    public dialogRef: MatDialogRef<BookAppointmentPopupComponent>,
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private FB: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    if (this.data.type === "newBooking") {
      this.patientId = this.data.patientId;
      this.patientDetails = this.data.patientDetails;
    }else if(this.data.type === "rescheduleBooking"){
      this.isSubmitBtnDisabled = false;
    } 
  }

  ngOnInit() {
    this.getSlotsByDate(this.selectedDate);
    this.generateAppointmentFrom();
  }

  generateAppointmentFrom(){
    this.appointmentFrom = this.FB.group({
      service: ['', Validators.required]
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getSlotsByDate(date) {
    this.showMatProgress = true;
    this.selectedDate = date
    const startDate = moment(this.selectedDate).format('YYYY-MM-DD');
    const day = moment(startDate).format('dddd');
    const url = `dashboard/4/camp-1?orgId=1&day=${day.toUpperCase()}&startDate=${startDate}`;
    this.httpService.get(url)
      .subscribe((response: any) => {
        this.appointmentData = response.data;
        if(this.selectedService.id)
          this.onChangeService({value: this.selectedService.resource.id});
        else
          this.selectedService = this.appointmentData[0];
        
          this.appointmentFrom.patchValue({service: this.selectedService.resource.id})
        this.showMatProgress = false;
      })
  }

  onSelectSlot(slot) {
    if(!slot.isTimeOut&&slot.slot_status !== 'UNAVAILABLE'){
      if (SELECTED_LIMIT) {
        const selectedNoOfSlots = this.selectedService.slots.filter(x => x.selected).length;
        slot.selected = selectedNoOfSlots < SELECTED_LIMIT;
      } else {
        slot.selected = !slot.selected;
      }
    }
    this.isSubmitBtnDisabled = this.selectedService.slots.filter(x => x.selected).length<=0;
  }

  onChangeService(resource) {
    console.log("resourceId", resource)
    this.selectedService = this.appointmentData.filter(item => parseInt(item.resource.id) === parseInt(resource.value))[0];
    this.resetSlotSelection();
  }

  resetSlotSelection() {
    this.selectedService.slots.map(item => {
      item.selected = false
    });
  }

  book() {
    console.log("this.data.type", this.data.type)
    if (this.data.type === "newBooking") {
      this.newBooking();
    }
    else if (this.data.type === "rescheduleBooking") {
      this.rescheduleBooking(this.data.bookingData)
    }
  }

  newBooking() {
    const selectedSlots = this.selectedService.slots.filter(x=> x.selected);
    if(selectedSlots.length){
      const registerData = {
        firstName: this.patientDetails.fname,
        lastName: this.patientDetails.lname,
        email: this.patientDetails.email,
        phoneNo: this.patientDetails.phone,
        mrn: this.patientDetails.mrn,
        userRole: "CUSTOMER",
        type: "player",
        patientId: this.patientId
      }
      this.showMatProgress = true
      this.httpService.post(`signup?customer=true`, registerData)
        .subscribe((response: any) => {
          const payload = [];
          selectedSlots.map(slot => {
            if (slot.selected) {
              payload.push({
                "userId": response.data[0].id,
                "startDate": moment(this.selectedDate).format('YYYY-MM-DD'),
                "startTime": slot.startTime,
                "endTime": slot.endTime,
                "finalRate": 0,
                "status": "UNAVAILABLE",
                "day": slot.day,
                "slotId": slot.id,
                "patientId": this.patientId,
                "site": {
                  "lastUpdatedDate": slot.site.lastUpdatedDate,
                  "id": slot.site.id,
                  "name": slot.site.name,
                  "status": slot.site.status,
                  "area": slot.site.area,
                  "internalPractice": slot.site.internalPractice,
                  "resourcesCount": slot.site.resourcesCount,
                  "enable": slot.site.enable,
                },
                "resource": {
                  "lastUpdatedDate": slot.resource.lastUpdatedDate,
                  "id": slot.resource.id,
                  "name": slot.resource.name,
                  "activeStatus": slot.resource.activeStatus,
                  "allowMultiple": slot.resource.allowMultiple,
                  "isCommunity": slot.resource.isCommunity,
                  "enable": slot.resource.enable,
                },
                "offerRate": slot.offerRate,
                "payment_status": "PAID"
              })
            }
          })

          const url = `offers`;
          this.httpService.post(url, payload)
            .subscribe((response: any) => {
              this.dialogRef.close({ event: 'yes' });
              this.toastr.success('You have booked Successfully', "Booked", { timeOut: 2000 })
              this.showMatProgress = false;
            }, error => {
              this.showMatProgress = false;
              this.dialogRef.close();
              this.toastr.warning(error.statusMessage, 'Error occured', {
                progressBar: true, timeOut: 3000
              });
            })
        }, error => {
          this.showMatProgress = false;
          this.dialogRef.close();
          this.toastr.warning(error.statusMessage, 'Error occured', {
            progressBar: true, timeOut: 3000
          });
        })
    }
  }

  rescheduleBooking(bookingData) {
    const payload = [];
    this.selectedService.slots.map(slot => {
      if (slot.selected) {
        bookingData.startDate = moment(this.selectedDate).format('YYYY-MM-DD');
        bookingData.startTime = slot.startTime;
        bookingData.endTime = slot.endTime;
        bookingData.slotId = slot.id;
        bookingData.resource = this.selectedService.resource;
        payload.push(bookingData);
      }
    });
    this.showMatProgress = true;
    const url = `bookings`;
    this.httpService.put(url, payload)
      .subscribe((response: any) => {
        this.dialogRef.close({ event: 'yes' });
        this.toastr.success('You have booked Successfully', "Booked", { timeOut: 2000 })
        this.showMatProgress = false;
      }, error => {
        this.showMatProgress = false;
        this.dialogRef.close();
        this.toastr.warning(error.statusMessage, 'Error occured', {
          progressBar: true, timeOut: 3000
        });
      })
  }

}
